import {
  EditorAddAudio,
  EditorAddImage,
  EditorAddVideo,
  SpineIcon,
} from '@/components/icon';
import { UserResourceType } from '@/interface/library';

const searchPanelConfigs = [
  {
    label: '图片',
    icon: <EditorAddImage />,
    value: UserResourceType.RESOURCE_TYPE_IMAGE,
  },
  {
    label: '视频',
    icon: <EditorAddVideo />,
    value: UserResourceType.RESOURCE_TYPE_VIDEO,
  },
  {
    label: 'BGM',
    icon: <EditorAddAudio />,
    value: UserResourceType.RESOURCE_TYPE_AUDIO,
  },
  {
    label: 'Spine',
    icon: <SpineIcon />,
    value: UserResourceType.RESOURCE_TYPE_SPINE,
  },
];

const publicConfigs = [
  {
    label: 'BGM',
    icon: <EditorAddAudio />,
    value: UserResourceType.RESOURCE_TYPE_AUDIO,
  },
];

const picConfigs = [
  {
    label: '图片',
    icon: <EditorAddImage />,
    value: UserResourceType.RESOURCE_TYPE_IMAGE,
  },
  {
    label: 'BGM',
    icon: <EditorAddAudio />,
    value: UserResourceType.RESOURCE_TYPE_AUDIO,
  },
];

export { picConfigs, publicConfigs, searchPanelConfigs };
